import React from "react";
import { Reveal, Kicker, CTAButton, Section } from "@/components/landing/kit";
import { COST } from "@/lib/site-data";

const CostAnalysis = () => (
  <Section id="cost" className="bg-[#F4F6FB] py-24 sm:py-32">
    <Reveal className="mx-auto mb-14 max-w-3xl text-center">
      <Kicker className="mb-5 justify-center">{COST.overline}</Kicker>
      <h2 className="text-balance font-heading text-4xl font-black leading-[0.98] tracking-tight text-[#0F1117] sm:text-6xl">
        {COST.heading} <span className="text-[#2D5BFF]">{COST.headingAccent}</span>
      </h2>
    </Reveal>

    <Reveal delay={0.05} className="mx-auto max-w-4xl rounded-3xl border border-[#E5E8F0] bg-white p-6 shadow-md sm:p-10">
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
        {/* leaks */}
        <div className="space-y-4">
          <p className="font-heading text-xs font-bold uppercase tracking-[0.22em] text-[#858D9E]">
            The annual leak
          </p>
          {COST.lineItems.map((li) => (
            <div
              key={li.label}
              className="flex items-center justify-between border-b border-[#E5E8F0] pb-4"
            >
              <span className="max-w-[70%] text-sm text-[#4B5262]">{li.label}</span>
              <span className="font-heading text-xl font-black tabular-nums text-[#DC2626]">
                {li.value}
              </span>
            </div>
          ))}
          <div className="rounded-2xl border border-[#2D5BFF]/30 bg-[#2D5BFF]/5 p-5">
            <p className="font-heading text-[11px] font-bold uppercase tracking-[0.2em] text-[#2D5BFF]">
              {COST.dailyBox.label}
            </p>
            <p className="mt-1 font-heading text-4xl font-black text-[#2D5BFF]">
              {COST.dailyBox.value}
              <span className="text-lg text-[#858D9E]">{COST.dailyBox.unit}</span>
            </p>
          </div>
        </div>

        {/* gain */}
        <div className="flex flex-col justify-center rounded-2xl border border-[#059669]/30 bg-[#ECFDF5] p-6">
          <p className="font-heading text-[11px] font-bold uppercase tracking-[0.2em] text-[#059669]">
            {COST.gainBox.label}
          </p>
          <p className="mt-2 font-heading text-5xl font-black tabular-nums text-[#059669] sm:text-6xl">
            {COST.gainBox.value}
          </p>
          <p className="mt-3 text-sm leading-relaxed text-[#4B5262]">{COST.gainBox.sub}</p>
        </div>
      </div>

      <div className="mt-10 flex flex-col items-center gap-6 border-t border-[#E5E8F0] pt-10 text-center">
        <p className="max-w-2xl font-heading text-xl font-bold leading-snug text-[#0F1117] sm:text-2xl">
          {COST.punch}{" "}
          <span className="text-[#2D5BFF]">{COST.question}</span>
        </p>
        <CTAButton size="lg" testId="cost-cta-button">
          {COST.cta}
        </CTAButton>
      </div>
    </Reveal>

    <p className="mx-auto mt-6 max-w-2xl text-center text-xs leading-relaxed text-[#8A909E]">
      Figures shown are illustrative estimates for explanation only — not a promise of
      earnings, savings, or results. Individual results vary.
    </p>
  </Section>
);

export default CostAnalysis;
